import React, { useCallback, useMemo } from 'react';
import { Table as AntdTable } from 'antd';
import propTypes, { any } from 'prop-types';

import style from './index.less';

const { Column, ColumnGroup } = AntdTable;

function Table({
  columns,
  children,
  dataSource = [],
  loading = false,
  className = '',
  rowKey = e => e.id,
  fixed = false,
  pagination = false,
  onRow = () => null,
  scroll = {},
  ...rest
}) {
  const props = { columns, children, dataSource, loading, className, rowKey, fixed, pagination, onRow, scroll, ...rest };

  const getColumn = useCallback(columns => {
    if (!columns) {
      return columns;
    }
    return columns.map(column => {
      const { render, dataIndex } = column;
      if (!render) {
        return {
          ...column,
          render: (columnName, data) => {
            const value = data[dataIndex];
            return (
              <div className={style.td} title={value}>
                {value}
              </div>
            );
          }
        };
      }
      return {
        ...column,
        render: (text, record, index) => {
          const ele = render(text, record, index);
          if (React.isValidElement(ele)) {
            return ele;
          }
          let content = ele;
          if (ele !== null && ele !== undefined) {
            content = typeof ele === 'string' ? ele : ele.toString();
          }
          return (
            <div className={style.td} title={ele}>
              {content}
            </div>
          );
        }
      };
    });
  }, []);

  const childrenClone = useMemo(() => {
    return React.Children.map(children, child => {
      if (!child) {
        return child;
      }
      const { props } = child;
      const { render, dataIndex } = props;
      return React.cloneElement(child, {
        render: (text, record, index) => {
          if (render) {
            const ele = render(text, record, index);
            if (React.isValidElement(ele)) {
              return ele;
            }
            let content = ele;
            if (ele !== null && ele !== undefined) {
              content = typeof ele === 'string' ? ele : ele.toString();
            }
            return (
              <div className={style.td} title={ele}>
                {content}
              </div>
            );
          }
          const value = record[dataIndex];
          return (
            <div className={style.td} title={value}>
              {value}
            </div>
          );
        }
      });
    });
  }, [children]);

  const propColumns = useMemo(() => {
    return getColumn(columns);
  }, [columns]);

  return (
    <AntdTable {...props} className={`${style.table} ${props.className}`} columns={propColumns}>
      {childrenClone}
    </AntdTable>
  );
}

Table.propTypes = {
  dataSource: propTypes.array,
  columns: propTypes.array,
  loading: propTypes.bool,
  className: propTypes.string,
  rowKey: propTypes.oneOfType([propTypes.string, propTypes.func]),
  fixed: propTypes.bool,
  pagination: any,
  onRow: propTypes.func,
  scroll: propTypes.object
};

Table.Column = Column;
Table.ColumnGroup = ColumnGroup;

export default Table;
